import { UserDisabilityPreference } from "shared/models/settings";

export interface IApiErrorMessages<TModel> {
  fields: {
    [fieldName in keyof TModel]: { [errorName: string]: string };
  };
}

export enum SortOrder {
  Asc,
  Desc,
}

export interface IPhoto {
  id: string;
  fileName: string;
}

export interface ISortConfig {
  name: "sender" | "sent" | "closingDate";
  order: SortOrder;
}

export interface IClientAlertSortConfig {
  name: "senderName" | "alertSentDate" | "breakdownClosingDate";
  order: "asc" | "desc";
}

export interface IClientAlertFilterConfig {
  dateSentFrom: string;
  dateSentTo: string;
}

export enum JobItemReadStatus {
  Read,
  Unread,
}

export interface IJobFilterParams {
  sort: ISortConfig;
  textFilter?: string;
  sentFrom?: string;
  sentTo?: string;
  pageNumber?: number;
  pageSize?: number;
  genderIds?: number[];
  appearanceIds?: number[];
  disabilityPreference?: UserDisabilityPreference;
  minPlayingAge: number | null | undefined;
  maxPlayingAge: number | null | undefined;
  minimumHeight: number | null;
  maximumHeight: number | null;
  productionTypes?: number[];
  contractTypes?: number[];
  productionCountries?: string[];
  castingCountries?: string[];
  senderId?: string;
  readStatus?: JobItemReadStatus;
  isSuggested?: boolean;
  productionLocationIds?: string[];
}

export interface IMakeSuggestionsFilterParams {
  skip: number;
  take?: number;
  textFilter?: string;
  heritageAndEthnicityInfo?: string;
  gender?: number[];
  agents?: string[];
  whichCV?: string;
  playingAgeFrom?: number;
  playingAgeTo?: number;
  appearances?: number[];
  locationId?: string[];
  heritageAndEthnicity?: number[];
  heritageAndEthnicityFilterMode?: number;
}
